export const theme = {
  breakpoints: {
    desktop: "1300px",
    tablet: "1000px",
    mobile: "460px",
    mini: "370px",
    mobileWide: "550px",
    phablet: "670px",
    tabletNarrow: "820px",
    tabletWide: "1200px",
    desktopMid: "1370px",
    largeDesktop: "1600px",
  },
  colors: {
    primary: "#971B2F",
    input: {
      default: "#f7f7f7",
    },
    text: {
      default: "#000000",
      white: "#ffffff",
      grayDark: "#444444",
      grayLight: "#676767",
      grayMedium: "#888888",
      graySoft: "#999999",
      grayDeep: "#505050",
    },
    background: {
      default: "#F7F7F7",
      white: "#FFFFFF",
      primary: "#971B2F",
      black: "#000000",
    },
    button: {
      black: "#000000",
      white: "#FFFFFF",
    },
    border: {
      black: "#000000",
      gray: "#b1b1b1",
    },
  },
  fontWeights: {
    regular: "400",
    bold: "700",
  },
};

export type AppTheme = typeof theme;
